import {getStore} from "trim-redux";
import {translateKey} from "./values";

export const TablePage = 10;
export const TableCount = [10,20,50,100,200];
export const TableCountForCat = [3,5,10];

export const rolesWithName = () => {
    let rwn = [
        {
            value: "admin",
            type: "admin",
            name : translateKey('admin')
        },
        {
            value: "supplier",
            type: "normal",
            name : translateKey('supplier')
        },
        {
            value: "transport",
            type: "normal",
            name : translateKey('transport')
        },
        {
            value: "user",
            type: "normal",
            name : translateKey('user')
        },
    ];
    return rwn;
};
export const industries = ["restaurants" , "markets"];

export const RWN = () => {
    let rwn = {
        admin: translateKey('admin'),
        supplier: translateKey('supplier'),
        user: translateKey('user'),
        transport: translateKey('transport'),
    };
    return rwn;
};
export function isAdmin(){
    let user = getStore('user');
    try {
        if(user.role.type === "admin"){
            return true
        }
    }catch (e) {
        return false
    }
    return false
}
export function isSupplier(){
    let user = getStore('user');
    try {
        if(user.role.name === "supplier"){
            return true
        }
    }catch (e) {
        return false
    }
    return false
}
export function isCourier(){
    let user = getStore('user');
    try {
        if(user.role.name === "transport"){
            return true
        }
    }catch (e) {
        return false
    }
    return false
}
export function isUser(){
    let user = getStore('user');
    try {
        if(user.role.name === "user"){
            return true
        }
    }catch (e) {
        return false
    }
    return false
}
export function isUnSignedSupplier(){
    let user = getStore('user');
    try {
        if(user.role.name === "supplier"){
            if(!user.signed_contract_at){
                return true
            }else{
                return false
            }
        }
    }catch (e) {
        return false
    }
    return false
}
export function hasPanel(){
    let user = getStore('user');
    try {
        if(user.role.type === "admin" || user.role.name === "supplier"){
            return true
        }
    }catch (e) {
        return false
    }
    return false
}